import clsx from "clsx";
import { useTheme } from "../context/ThemeContext";

export const GradientBorderBox = ({ children, title, className }: { children: React.ReactNode, title?: string, className?: string }) => {
    const { theme } = useTheme();
    return <div className={clsx("p-6 relative transition-colors duration-300", className)}>
        <div
            className="absolute inset-0 rounded-[24px] pointer-events-none"
            style={{
                padding: '1px',
                background: `linear-gradient(to bottom, ${theme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.06)'}, ${theme === 'dark' ? 'rgba(255,255,255,0)' : 'rgba(0,0,0,0)'}`,
                WebkitMask:
                    'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
                zIndex: 10,
            }}
        ></div>
        {title && <h2 className="text-xl text-black dark:text-white mb-4">{title}</h2>}
        {children}
    </div>;
};